module.exports = __webpack_public_path__ + "img/arrow-drop-up-line.c1a9fc6e.svg";